import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, firstValueFrom } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '@env/environment';
import { Instance } from '@models/instance.model';
import { OccupationSummary } from '@models/unit.model';

@Injectable({
  providedIn: 'root'
})
export class InstanceService {

  instance!: Instance;

  constructor(private http: HttpClient) { }

  load(): Promise<void> {
    const url = `${environment.apiBaseUrl}/${environment.instanceUuid}/instance`;
    const queryParams = { append: 'summary,perspectives,units,buildings,pois,infos,unitsFilter,config,applicationFormConfig' }

    return firstValueFrom(
      this.http.get(url, { params: queryParams }).pipe(
        map((res: any) => new Instance(res?.data)),
        tap(instance => this.instance = instance)
      )
    ).then(() => { });
  }

  getOccupation(params: any): Observable<OccupationSummary> {
    const url = `${environment.apiBaseUrl}/${environment.instanceUuid}/occupation`;

    return this.http.get(url, { params: params }).pipe(
      map((res: any) => new OccupationSummary(res?.data))
    );
  }
}
